var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.675 104.825L15.325 114.575C16.5 116.625 18.175 118.25 20.175 119.425L40.325 84.525H0C0 86.8 0.575 89.075 1.75 91.125L9.675 104.825Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 43.4749L43.85 8.57495C41.875 9.74995 40.175 11.35 39 13.425L1.75 77.925C0.6 79.925 0 82.2 0 84.525H40.325L64 43.4749Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.851 119.425C109.826 118.25 111.526 116.65 112.701 114.575L115.051 110.55L126.276 91.125C127.451 89.075 128.026 86.8 128.026 84.525H87.6758L96.2508 101.375L107.851 119.425Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9996 43.4749L84.1496 8.57495C82.1746 7.39995 79.8996 6.82495 77.5496 6.82495H50.4496C48.0996 6.82495 45.8246 7.47495 43.8496 8.57495L63.9996 43.4749Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6754 84.525H40.3254L20.1504 119.425C22.1254 120.6 24.4004 121.175 26.7504 121.175H101.25C103.6 121.175 105.875 120.525 107.85 119.425L87.6754 84.525Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.625 45.6749L89 13.425C87.825 11.375 86.15 9.74995 84.15 8.57495L64 43.4749L87.675 84.525H127.925C127.925 82.25 127.35 79.975 126.175 77.925L107.625 45.6749Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google-drive.ed594a1851c2cc4bd585120ecc6b27b5.svg";
export { ForwardRef as ReactComponent };